import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Pipe({
  name: 'doc'
})
export class DocPipe implements PipeTransform {

  constructor(private afFirestore: AngularFirestore) {}

  transform(value: DocumentReference|string, ...args: any[]): Observable<any> {  
    
    if( typeof value == "object" ){ 
      return this.afFirestore.doc<any>(value.path).valueChanges();      
    }
    else{      
      return this.afFirestore.doc<any>(args[0]+"/"+value).valueChanges();
    }
    
  }

}
